import React, { useContext } from 'react';
import {
  Box, Typography
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import NavBar from './components/NavBar';
import FilterBar from './components/FilterBar';
import theme from './theme';
import { DataAndFilterContext } from './context/DataAndFilterContext';
import { useGlobalLoading } from './context/GlobalLoadingContext';
import InsightsTrends from './components/data_visualizations/InsightsTrends';
import InsightsTrendsCharts from './components/data_visualizations/InsightsTrendsCharts';
import InsightsHeatmaps from './components/data_visualizations/InsightsHeatmaps';
import InsightsTable from './components/data_visualizations/InsightsTable';
import TopInsightsByType from './components/insights/TopInsightsByType';
import UnifiedInsightsTable from './components/detail/tables/InsightsTable';
import { Button } from '@mui/material';
import { useState } from 'react';


function UsageInsights() {
  //const { filteredData, loading } = useContext(DataAndFilterContext);  // Get filtered conversations from context
  const { filteredData } = useContext(DataAndFilterContext);  // Get filtered conversations from context
  const { loading } = useGlobalLoading();  // use the actual global loading context
  const [isModalOpen, setModalOpen] = useState(false); // State to manage modal visibility

  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <Box sx={{ padding: 3 }}>
        <Typography variant="h4" gutterBottom>
          Usage Insights
        </Typography>
        <FilterBar />
        <Typography variant="h6" sx={{ mt: 1, mb: 1 }}>
          Interview insights
        </Typography>
        <UnifiedInsightsTable
          customerStories={filteredData}
          /* omit jobName to avoid any pre-filtering; DataAndFilterContext already scoped data */
        />
        <br /><br />
        <InsightsHeatmaps />
        <br /><br />
        {/* 
        <InsightsTrends />
        <br /><br />
        <TopInsightsByType />
        <br /><br />
        <InsightsTrendsCharts />
        <br /><br />
        <InsightsTable />
        <br /><br />
        */}
      </Box>
    </ThemeProvider>
  );
  
}

export default UsageInsights;
